import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["numberField"]

  selectPreset(event) {
    this.numberFieldTarget.value = event.target.value
  }

  customChanged() {
    const value = this.numberFieldTarget.value
    const radios = this.element.querySelectorAll('input[type="radio"]')

    radios.forEach(radio => {
      radio.checked = radio.value === value
    })
  }
}
